module.exports = __webpack_public_path__ + "static/media/small-business-square.b883570d.jpg";